export default __webpack_public_path__ + "static/media/what-makes-you-beautiful.ba91e8e4.jpg";